import React, { useState } from "react";

const tooltipItems = [
  { id: "top", label: "Hover Top", position: "top", text: "Useful for verifying tooltip placement above a trigger." },
  { id: "right", label: "Hover Right", position: "right", text: "Helpful when testing hover interactions near the viewport edge." },
  { id: "bottom", label: "Hover Bottom", position: "bottom", text: "Use this to confirm tooltip visibility below compact controls." },
  { id: "left", label: "Hover Left", position: "left", text: "Great for testing directional popups and overlap handling." },
];

export default function ToolTips() {
  const [activeTooltip, setActiveTooltip] = useState(null);

  return (
    <div className="practice-demo-card">
      <h3>Tool Tips</h3>
      <p>
        Hover or focus the triggers below to inspect tooltip direction, positioning,
        and interaction behavior across pointer and keyboard usage.
      </p>

      <div className="tooltip-demo-grid">
        {tooltipItems.map((item) => (
          <div key={item.id} className="tooltip-target">
            <button
              type="button"
              className="tooltip-trigger"
              onMouseEnter={() => setActiveTooltip(item.id)}
              onMouseLeave={() => setActiveTooltip(null)}
              onFocus={() => setActiveTooltip(item.id)}
              onBlur={() => setActiveTooltip(null)}
            >
              {item.label}
            </button>

            {activeTooltip === item.id && (
              <div className={`demo-tooltip ${item.position}`} role="tooltip">
                {item.text}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
